(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mikan-mobile-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    for (const menu of document.querySelectorAll('.mikan-mobile-filters details[open], .mikan-desktop-nav details[open]')) {
      if (!menu.contains(event.target)) menu.open = false;
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    for (const menu of document.querySelectorAll('.mikan-mobile-filters details[open], .mikan-desktop-nav details[open]')) {
      if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
      menu.open = false;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mikan-product-image-sizing"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.card-gallery[data-product-id] .product-media__image, .resource-card[data-resource-type="product"] .resource-card__image';
    const registered = new WeakSet();
    const measured = new WeakMap();
    const cache = new Map();

    function bounds(image) {
      const ratio = Math.min(1, 160 / Math.max(image.naturalWidth, image.naturalHeight));
      const width = Math.max(1, Math.round(image.naturalWidth * ratio));
      const height = Math.max(1, Math.round(image.naturalHeight * ratio));
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return null;
      context.drawImage(image, 0, 0, width, height);
      const pixels = context.getImageData(0, 0, width, height).data;
      const background = (x, y) => {
        const i = (y * width + x) * 4;
        return pixels[i + 3] < 24 || (pixels[i] > 244 && pixels[i + 1] > 244 && pixels[i + 2] > 244);
      };
      let edge = 0;
      let white = 0;
      for (let x = 0; x < width; x++) {
        white += Number(background(x, 0)) + Number(background(x, height - 1));
        edge += 2;
      }
      for (let y = 0; y < height; y++) {
        white += Number(background(0, y)) + Number(background(width - 1, y));
        edge += 2;
      }
      if (white / edge < 0.98) return null;
      let left = width;
      let right = -1;
      let top = height;
      let bottom = -1;
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          if (background(x, y)) continue;
          left = Math.min(left, x);
          right = Math.max(right, x);
          top = Math.min(top, y);
          bottom = Math.max(bottom, y);
        }
      }
      if (right < left || bottom < top) return null;
      left = Math.max(0, left - 2);
      top = Math.max(0, top - 2);
      right = Math.min(width, right + 3);
      bottom = Math.min(height, bottom + 3);
      const span = Math.max(right - left, bottom - top);
      if (span < Math.max(width, height) * 0.3) return null;
      const scale = 88 / span;
      return {
        width: width * scale,
        height: height * scale,
        left: 50 - (left + right) * scale / 2,
        top: 50 - (top + bottom) * scale / 2
      };
    }

    function measureSource(source) {
      if (cache.has(source)) return cache.get(source);
      const pending = new Promise(resolve => {
        const sample = new Image();
        sample.crossOrigin = 'anonymous';
        sample.onload = () => {
          try { resolve(bounds(sample)); } catch { resolve(null); }
        };
        sample.onerror = () => resolve(null);
        sample.src = source;
      });
      if (cache.size >= 120) cache.delete(cache.keys().next().value);
      cache.set(source, pending);
      return pending;
    }

    async function normalize(image) {
      if (!image.complete || !image.naturalWidth || !image.matches(selector)) return;
      const source = image.currentSrc || image.src;
      if (measured.get(image) === source) return;
      measured.set(image, source);
      for (const name of ['width', 'height', 'left', 'top']) {
        image.style.removeProperty(`--mikan-image-${name}`);
      }
      try {
        const result = await measureSource(source);
        if (!result || !image.isConnected || (image.currentSrc || image.src) !== source) return;
        for (const [name, value] of Object.entries(result)) {
          image.style.setProperty(`--mikan-image-${name}`, `${value.toFixed(3)}%`);
        }
      } catch {
        return;
      }
    }

    const visibility = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        normalize(entry.target);
        visibility.unobserve(entry.target);
      }
    }, { rootMargin: '200px' });

    function register(root) {
      const images = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
      for (const image of images) {
        if (registered.has(image)) continue;
        registered.add(image);
        image.addEventListener('load', () => normalize(image));
        visibility.observe(image);
      }
    }

    function start() {
      register(document);
      new MutationObserver(records => {
        for (const record of records) {
          for (const node of record.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) register(node);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
